import React, { useEffect, useState } from 'react';
import FilterTag from '../../../../components/filter-tag/FilterTag';
import './HomeFilter.scss';
import HomeFilterButton from '../../../../components/home-filter-button/HomeFilterButton';
import HomeSortButton from '../../../../components/home-sort-button/HomeSortButton';
import AdvancedFilterButton from '../../../../components/advanced-filter-button/AdvancedFilterButton';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store/store';
import {
  filterVacancies,
  toggleVacanciesTagSelection,
  uncheckVacanciesTags,
  toggleActiveFilterItem,
  setActiveFilterText,
  clearActiveFilters,
} from '../../../../store/slices/vacanciesSlice';
import Option from '../../../../models/option.interface';
import { useTranslation } from 'react-i18next';

const HomeFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [isTagSelected, setIsTagSelected] = useState(false);
  const tagList = useSelector(
    (state: RootState) => state.vacanciesReducer.tagList
  );
  const activeFilters = useSelector(
    (state: RootState) => state.vacanciesReducer.activeFilters
  );

  const sectorOptions: { name: string; id: string }[] = t('sectorOptions', { returnObjects: true });
  const jobTypeList: { name: string; id: string }[] = t('jobTypeList', { returnObjects: true });

  const activeCount = activeFilters.sector.length + activeFilters.jobType.length;
  const hasAdvancedFilters = activeCount > 0 || !!(activeFilters.location || activeFilters.position);

  useEffect(() => {
    setIsTagSelected(tagList.some((tag) => tag.selected));
    dispatch(filterVacancies());
  }, [dispatch, tagList]);

  function uncheckAllTags(): void {
    dispatch(uncheckVacanciesTags());
    dispatch(clearActiveFilters());
  }

  function toggleSelectedTag(selectedOption: Option): void {
    dispatch(toggleVacanciesTagSelection(selectedOption));
  }

  function removeSectorChip(id: string): void {
    dispatch(toggleActiveFilterItem({ key: 'sector', value: id }));
  }

  function removeJobTypeChip(id: string): void {
    dispatch(toggleActiveFilterItem({ key: 'jobType', value: id }));
  }

  return (
    <div className='filter-row d-flex align-items-center flex-wrap'>
      <HomeFilterButton tagList={tagList} selectOption={toggleSelectedTag} />

      <AdvancedFilterButton
        sectorOptions={sectorOptions}
        jobTypeOptions={jobTypeList}
        selectedSectors={activeFilters.sector}
        selectedJobTypes={activeFilters.jobType}
        onToggleSector={(id) => dispatch(toggleActiveFilterItem({ key: 'sector', value: id }))}
        onToggleJobType={(id) => dispatch(toggleActiveFilterItem({ key: 'jobType', value: id }))}
        activeCount={activeCount}
      />

      <div className='filter-selected mobile-hidden'>
        <div className='d-flex tag-container'>
          {tagList.map((tag) => {
            if (!tag.selected) return null;
            return (
              <FilterTag
                uncheckTag={toggleSelectedTag}
                key={tag.name}
                icon={tag.icon}
                name={tag.name}
              />
            );
          })}

          {activeFilters.sector.map((id) => {
            const opt = sectorOptions.find((o) => o.id === id);
            if (!opt) return null;
            return (
              <FilterTag
                key={`sector-${id}`}
                name={opt.name}
                uncheckTag={() => removeSectorChip(id)}
              />
            );
          })}

          {activeFilters.jobType.map((id) => {
            const opt = jobTypeList.find((o) => o.id === id);
            if (!opt) return null;
            return (
              <FilterTag
                key={`jobType-${id}`}
                name={opt.name}
                uncheckTag={() => removeJobTypeChip(id)}
              />
            );
          })}
        </div>

        {(isTagSelected || hasAdvancedFilters) && (
          <button className='clean-button' onClick={uncheckAllTags}>
            {t('candidateHomePage.filter.clearButton')}
          </button>
        )}
      </div>

      <div className='filter-inputs d-flex align-items-center'>
        <input
          className='filter-input'
          type='text'
          placeholder={t('candidateHomePage.filter.location')}
          value={activeFilters.location}
          onChange={(e) => dispatch(setActiveFilterText({ key: 'location', value: e.target.value }))}
        />
        <input
          className='filter-input'
          type='text'
          placeholder={t('candidateHomePage.filter.position')}
          value={activeFilters.position}
          onChange={(e) => dispatch(setActiveFilterText({ key: 'position', value: e.target.value }))}
        />
      </div>

      <div className='no-mobile-hidden'>
        <HomeSortButton />
      </div>
    </div>
  );
};

export default HomeFilter;
